import React, { useEffect, useState } from 'react';
import { fetchPaginatedAccounts, fetchUsersForAccount } from 'services';
import { showError, sortArray } from 'utils';

const AccountsDropdown = props => {
  const [accountsLoading, setAccountsLoading] = useState<boolean>(true);
  const [usersLoading, setUsersLoading] = useState<boolean>(true);
  const [accounts, setAccounts] = useState<Record<string, any>[]>([]);
  const [users, setUsers] = useState<Record<string, any>[]>([]);
  const [selectedAccount, setSelectedAccount] = useState<string>('');
  const {
    value,
    onChange,
    showUserSelect,
  } = props;

  const fetchAccounts = async () => {
    try {
      const response = await fetchPaginatedAccounts({
        page: 0,
        limit: 1000,
      });
      setAccounts(response.items);
    } catch (e) {
      showError(e);
    } finally {
      setAccountsLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
    if (!showUserSelect) {
      setSelectedAccount(value);
    }
  }, [value]);

  const fetchAccountUsers = async (id: string) => {
    try {
      const response = await fetchUsersForAccount({
        page: 0,
        limit: 20,
        accountId: id,
      });
      setUsers(response.items);
    } catch (e) {
      showError(e);
    } finally {
      setUsersLoading(false);
    }
  };

  const getAccountUsers = () => {
    const getUserOptions = () => sortArray(users, 'full_name').map((user, i) => (
      <option key={i} value={user.objectId}>{user.full_name}</option>),
    );

    const handleUserChange = (id: string) => {
      const [user] = users.filter(user => user.objectId === id);
      onChange(user);
    };

    return (
      <select
        value={value.objectId}
        disabled={usersLoading}
        className='form-control mt-4'
        onChange={e => handleUserChange(e.target.value)}
      >
        <option value='none' hidden={!!value?.full_name}>Select a User</option>
        {users.length && getUserOptions()}
      </select>
    );
  };

  const getAccountOptions = () => sortArray(accounts, 'name').map((account, i) => (
    <option key={i} value={account.objectId}>{account.name}</option>
  ));

  const handleAccountChange = (id: string) => {
    setSelectedAccount(id);
    if (!showUserSelect) {
      onChange(id);
    } else {
      fetchAccountUsers(id);
    }
  };

  return (
    <div>
      <select
        value={selectedAccount}
        disabled={accountsLoading}
        className='form-control'
        onChange={e => handleAccountChange(e.target.value)}
      >
        <option value='none' hidden={!!selectedAccount}>Select an Account</option>
        {accounts.length && getAccountOptions()}
      </select>
      {(showUserSelect && !!selectedAccount) && getAccountUsers()}
    </div>
  );
};

export default AccountsDropdown;